export const SERVICE_MENU_ITEMS = [
    {
        category: "Armonización Facial",
        items: [
            "RostroDorado (Sustentación)",
            "Rinomodelación",
            "Corrección de ojeras",
            "Perfilamiento, aumento e hidratación de labios",
            "Skinbooster: hidratación profunda",
            "Manejo de arrugas profundas faciales",
            "Definición mandibular"
        ]
    },
    {
        category: "Toxina Botulínica (BOTOX)",
        items: [
            "Manejo de líneas de expresión",
            "Bruxismo",
            "Sonrisa triste",
            "Sonrisa gingival"
        ]
    },
    {
        category: "Calidad de Piel",
        items: [
            "Peeling químico",
            "Detox facial profundo",
            "Manejo de manchas",
            "Manejo de acné",
            "NCTF 135HA",
            "Sueroterapia"
        ]
    },
    {
        category: "Bioestimulación & Tecnologías",
        items: [
            "Bioestimulación: Harmonyca, Sculptra, Radiesse",
            "Láser de CO2: poros, manchas, cauterización",
            "Endolift láser: Perfil facial definido, bye papada",
            "Láser"
        ]
    }
];
